// สิทธิ์ในระบบนี้ ฝั่งหน้าเว็บ
//
// **ใช้เพื่อจัดหน้าจอเท่านั้น** — ซ่อนเมนูที่กดไปก็ไม่มีสิทธิ์ ไม่ใช่การกันสิทธิ์
// ตัวจริงอยู่ที่ server (server/config/roles.ts + middleware/require-admin.ts)
// ชื่อ role ต้องตรงกับสองที่นั้นและกับที่ตั้งไว้ใน IAM
import type { WazzupSession } from "./session";

export const ROLE_ADMIN = "Agency Intelligence Admin";
export const ROLE_USER = "Agency Intelligence User";

const norm = (s: string) => s.trim().toLowerCase().replace(/\s+/g, " ");

const has = (session: WazzupSession | null, role: string) =>
  !!session?.roles?.some((r) => norm(r) === norm(role));

export const isAdmin = (session: WazzupSession | null) => has(session, ROLE_ADMIN);

/** ไม่ใช่ Admin = ถูกจำกัดสิทธิ์ ไม่ว่าจะถือ role User หรือไม่มี role ของระบบนี้เลย */
export const isRestricted = (session: WazzupSession | null) => !isAdmin(session);

/** ข้อความเดียวที่ผู้ใช้เห็นเมื่อสิทธิ์ไม่ถึง — ตรงกับที่ server ตอบ */
export const NO_ACCESS = "คุณยังไม่ได้รับสิทธิ์เข้าระบบ";

/** เมนูฝั่งผู้ดูแล (Setting, Corporate Performance) เปิดให้ Admin เท่านั้น */
export const canSeeAdminMenus = (session: WazzupSession | null) => isAdmin(session);
